<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Galeri"
    }
</script>

<style scoped>

</style>